module.exports = __webpack_public_path__ + "img/proxy.7537d7f5.svg";